import { NavLink, useParams } from "react-router-dom";
import { useAccount } from "../platform/AccountProvider";
import { can, PROFILE_MODULES } from "../platform/model/access";

export function ProfileSubnav() {
  const { profileId } = useParams();
  const { access, visibleProfiles, enabledModules } = useAccount();
  if (profileId === undefined) return null;
  const profile = visibleProfiles.find((item) => item.id === profileId);
  if (profile === undefined) return null;
  const enabled = enabledModules(profileId);
  const links = [
    { tab: "overview", label: "Visão geral" },
    ...PROFILE_MODULES.filter((module) => enabled.has(module.id)).map((module) => ({
      tab: module.legacyTab,
      label: module.label,
    })),
    ...(can(access, "report_pdf") ? [{ tab: "report", label: "Relatórios" }] : []),
  ];
  return (
    <nav className="profile-subnav" aria-label={`Áreas de ${profile.nome}`}>
      <div className="profile-subnav-heading">
        <span className="eyebrow">Perfil ativo</span>
        <strong>{profile.nome}</strong>
      </div>
      <div className="profile-subnav-links">
        {links.map((link) => (
          <NavLink key={link.tab} to={`/aluno/${profileId}/${link.tab}`}>
            {link.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
